import { render } from "./FacturationMain.vue?vue&type=template&id=5653a3d2&scoped=true"
import script from "./FacturationMain.vue?vue&type=script&lang=js"
export * from "./FacturationMain.vue?vue&type=script&lang=js"

import "./FacturationMain.vue?vue&type=style&index=0&id=5653a3d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5653a3d2"]])

export default __exports__